import { type CountryCode, CUSTOMER_SERVICE_URLS, type ProjectCode } from '@constants'

export function getCustomerServiceUrl(projectCode: ProjectCode | undefined, countryCode: CountryCode | undefined): string | undefined {
  if (!projectCode || !countryCode) return undefined
  return CUSTOMER_SERVICE_URLS[projectCode]?.[countryCode]
}
